import { ArrowBigUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type UpvoteButtonProps = {
  count: number
  voted: boolean
  onToggle: () => void
  disabled?: boolean
  className?: string
}

/**
 * Upvote control for feedback board cards: count + toggled state.
 * Stops propagation so it can live inside a clickable ListCard.
 */
export function UpvoteButton({ count, voted, onToggle, disabled, className }: UpvoteButtonProps) {
  return (
    <Button
      type="button"
      variant={voted ? 'secondary' : 'ghost'}
      size="sm"
      disabled={disabled}
      aria-pressed={voted}
      aria-label={voted ? `Remove upvote (${count} votes)` : `Upvote (${count} votes)`}
      className={cn('pointer-events-auto gap-1 px-2', voted && 'text-primary', className)}
      onClick={(e) => {
        e.stopPropagation()
        onToggle()
      }}
    >
      <ArrowBigUp className={cn('size-4', voted && 'fill-current')} aria-hidden />
      <span className="tabular-nums text-xs font-semibold">{count}</span>
    </Button>
  )
}
